export default function countryService($http, RESOURCES) {
  var service;

  service = {
    getAllCountries: getAllCountries,
  };

  return service;

  function getAllCountries() {
    return $http.get(RESOURCES.COUNTRY);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/country.service.js